export default __webpack_public_path__ + "static/media/1340.478a4568.png";